import { cn } from "src/common/utils";

const PGAnalyzeIcon = ({ className }: { className?: string }) => (
  <div className={cn(className, "bg-white rounded-sm p-0.5 flex items-center justify-center")}>
    <img src="/images/pganalyze-logo.png" alt="PGAnalyze" className="w-full h-full object-contain" />
  </div>
);

export default PGAnalyzeIcon;
